// Felder, die unverändert aus den Metadaten eines Reisetermins übernommen werden
const UNVERAENDERT_UEBERNOMMENE_FELDER = [
  'overnightInbound',
  'overnightOutbound',
  'hotelstartVorLandung',
  'rueckflugNachHotelende',
  'kalkPax',
  'minPax',
  'maxPax',
  'durchfuehrbareMinPax',
  'transferszenarioHin',
  'transferszenarioRueck',
  'skrFlugangebot',
  'vornachtMoeglich',
  'hotelnaechte',
  'fruehesterAbflug',
  'spaetesterAbflug',
  'fruehesteAnkunft',
  'spaetesteAnkunft',
  'releasefrist',
  'einkaufspreisVornachtDzProPerson',
  'erwarteteTermindurchfuehrungsquote',
  'vorverlaengerung',
  'hinflugMaxWartezeit',
  'rueckflugMaxWartezeit',
  'hinflugMaxAnzahlTransfergruppen',
  'rueckflugMaxAnzahlTransfergruppen',
];

// Gespeicherte Country Manager eines Termins für den Body von PUT reise/{kuerzel}/reisetermine/metadata
// Ohne mitgeschickte Liste leert der Core die Country Manager nicht, deshalb null, wenn sie nicht geladen sind
export function countryManagerKuerzelParam(metadata) {
  return metadata?.countryManagers?.map(cm => cm.countryManagerKuerzel) ?? null;
}

// Baut aus den geladenen Metadaten den Body für PUT reise/{kuerzel}/reisetermine/metadata
export function buildReiseterminMetadataParams(metadata) {
  const zielflughaefen = metadata.ziellandZielflughaefen ?? [];
  const abflughaefen = metadata.ziellandAbflughaefen ?? [];
  return {
    ...Object.fromEntries(UNVERAENDERT_UEBERNOMMENE_FELDER.map(feld => [feld, metadata[feld]])),
    ziellandZielflughaefenIataCodes: zielflughaefen.map(fh => fh.flughafenIataCode),
    ziellandAbflughaefenIataCodes: abflughaefen.map(fh => fh.flughafenIataCode),
    ziellandZielflughafenPrio: zielflughaefen.find(fh => fh.isPrio)?.flughafenIataCode || null,
    ziellandAbflughafenPrio: abflughaefen.find(fh => fh.isPrio)?.flughafenIataCode || null,
    weiterePartner: (metadata.weiterePartner ?? []).map(p => p.countryManagerKuerzel),
    countryManagerKuerzel: countryManagerKuerzelParam(metadata),
    // Rollover-Werte liegen nach dem Sidebar-Speichern als Boolean vor, die API erwartet 0/1
    restriktionenHinRollover:
      metadata.restriktionenHinRollover == null ? null : +metadata.restriktionenHinRollover,
    restriktionenRueckRollover:
      metadata.restriktionenRueckRollover == null ? null : +metadata.restriktionenRueckRollover,
  };
}
